export const STATS_LABEL_DATE_FORMAT = 'yyyy-MM'
